import React, { useEffect, useState } from "react";
import { useParams, Link, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import "./ExaminationCard.css";
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import IsLoading from "../../../../isLoading";

import "./AdmissionConfirmation.css";
import Logo from "../../../public_directory/public-routes-images/logos/Manga_Cons _Logo2.png";
import provostSig from "./provost signature.png";
let studentData, examCourses, carryOver;

export default function ExaminationCard() {
  const { adm } = useParams();
  const [searchParams] = useSearchParams();

  const level = searchParams.get("level");
  const semester = searchParams.get("semester");
  const session = searchParams.get("session");

  const encodedId = encodeURIComponent(adm);
  const encodedlevel = encodeURIComponent(level);
  const encodedsession = encodeURIComponent(session);
  const encodedsemester = encodeURIComponent(semester);
  const [loading, setLoading] = useState(false);

  
  async function getStudentData() {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/management/fetchStudentData/${encodedId}/${encodedlevel}/${encodedsession}/${encodedsemester}/exams_card`,
      )
      .then((response) => {
        studentData = response.data.studentData;
        examCourses = response.data.enrolled;
        carryOver = response.data.carryover;
        console.log(response);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }

  const titleSwitch = `${studentData?.academicInfo?.level}-${studentData?.academicInfo.pressent_semester}`;

  console.log(titleSwitch);

  function getExamTitle() {
    switch (titleSwitch) {
      case "100-First Semester":
        return "FIRST YEAR FIRST SEMESTER EXAMINATION";

      case "100-Second Semester":
        return "FIRST YEAR SECOND SEMESTER EXAMINATION";

      case "200-First Semester":
        return "SECOND YEAR FIRST SEMESTER EXAMINATION";

      case "200-Second Semester":
        return "SECOND YEAR SECOND SEMESTER EXAMINATION";

      case "300-First Semester":
        return "THIRD YEAR FIRST SEMESTER EXAMINATION";

      case "300-Second Semester":
        return "THIRD YEAR SECOND SEMESTER EXAMINATION";

      default:
        return "EXAMINATION SLIP";
    }
  }
  function getExamGNCourses() {
    switch (titleSwitch) {
      case "100-First Semester":
        return (
          <ul className="g g2 space1">
            <li>GNS 111</li>
            <li>GNS 112</li>
            <li>GST 116</li>
            <li>GST 111</li>
            <li>GST 112</li>
            <li>GST 113</li>
            <li>GST 114</li>
            <li>GST 115</li>
          </ul>
        );

      case "100-Second Semester":
        return (
          <ul className="g g2 space1">
            <li>GNS 121</li>
            <li>GNS 122</li>
            <li>GNS 123</li>
            <li>GNS 124</li>
            <li>GNS 125</li>
            <li>GNS 126</li>
            <li>GNS 127</li>
            <li>GNS 128</li>
          </ul>
        );

      case "200-First Semester":
        return (
          <ul className="g g2 space1">
            <li>GNS 211</li>
            <li>GNS 212</li>
            <li>GNS 213</li>
            <li>GNS 214</li>
            <li>GNS 215</li>
            <li>GNS 216</li>
            <li>GNS 217</li>
            <li>GNS 218</li>
          </ul>
        );

      case "200-Second Semester":
        return (
          <ul className="g g2 space1">
            <li>GNS 221</li>
            <li>GNS 222</li>
            <li>GNS 223</li>
            <li>GNS 224</li>
            <li>GNS 225</li>
            <li>GNS 226</li>
            <li>GNS 227</li>
            <li>GNS 228</li>
            <li>GNS 229</li>
            <li>GST 221</li>
          </ul>
        );

      default:
        return <p>EXAMINATION SLIP</p>;
    }
  }

  function getExamMWCourses() {
    switch (titleSwitch) {
      case "100-First Semester":
        return (
          <ul className="g g2 space1">
            <li>MID 111</li>
            <li>MID 112</li>
            <li>GST 112</li>
            <li>GST 113</li>
            <li>GST 115</li>
            <li>GST 111</li>
            <li>MID 113</li>
            <li>GST 116</li>
          </ul>
        );

      case "100-Second Semester":
        return (
          <ul className="g g2 space1">
            <li>MID 121</li>
            <li>MID 122</li>
            <li>MCB 121</li>
            <li>MID 123</li>
            <li>NTD 121</li>
            <li>MID 124</li>
            <li>MID 125</li>
            <li>MID 126</li>
            <li>MID 127</li>
          </ul>
        );

      case "200-First Semester":
        return (
          <ul className="g g2 space1">
            <li>MID 211</li>
            <li>MID 212</li>
            <li>MID 213</li>
            <li>MID 214</li>
            <li>ENG 211</li>
            <li>MID 215</li>
            <li>MID 216</li>
            <li>MID 217</li>
          </ul>
        );

      case "200-Second Semester":
        return (
          <ul className="g g2 space1">
            <li>MID 221</li>
            <li>MID 222</li>
            <li>MID 223</li>
            <li>MID 224</li>
            <li>MID 225</li>
            <li>MID 226</li>
            <li>MID 227</li>
            <li>MID 228</li>
          </ul>
        );

      default:
        return <p>EXAMINATION SLIP</p>;
    }
  }
  useEffect(() => {
    getStudentData();
  }, []);

  return (
    <>
      {loading ? <IsLoading /> : null}
      <section className="sectionExamsCard fx-ac fx-jc fx-cl space3">
        <div className="examsContPRINTCONT fx-cl space3">
          <div className="examsContDetails fx-cls space2 ">
            <div className="admletterHeader fx-ac fx-jc space4">
              <figure>
                <img src={Logo} alt="logo" />
              </figure>
              <div className="fx-cl fx-jc">
                <h2 style={{ fontSize: "1.4rem" }}>
                  MANGA COLLEGE OF NURSING SCIENCES, ZURU
                </h2>
                <span style={{ color: "red" }}>{"(Online Portal)"}</span>
                <section>EXAMINATION MENTORING COMMITTEE</section>
              </div>
            </div>
            <div className="examsGecco">
              <figure className="examscardPassport">
                <img src={studentData?.personalInfo?.passport} alt="" />
              </figure>
              <p
                style={{
                  textAlign: "center",
                  textTransform: "capitalize",
                  marginBottom: "2.5rem",
                }}
              > 

                {`Student Examination Card Slip, ${studentData?.academicInfo?.state?.current_session} Academic Session`}
              </p>
            </div>
            <div className="examsCardFloat">
              <div className="fx-cl space3">
                <div className="fx-cl space1">
                  <h3>STUDENT'S INFORMATION</h3>
                  <ul className="fx-cl spacem">
                    <li>
                      <strong>Name:</strong>{" "}
                      {studentData?.personalInfo.first_Name.toUpperCase() +
                        " " +
                        studentData?.personalInfo.sur_Name +
                        " " +
                        studentData?.personalInfo.other_Name}
                    </li>
                    <li>
                      <strong>Admission Number:</strong>{" "}
                      {studentData?.admission_number}
                    </li>
                    <li>
                      <strong>Programme:</strong>{" "}
                      {studentData?.academicInfo.programme}
                    </li>
                    <li>
                      <strong>Department:</strong>{" "}
                      {studentData?.academicInfo.department}
                    </li>

                    <li>
                      <strong>Level:</strong> {studentData?.academicInfo.level}
                    </li>
                    <li>
                      <strong>Phone Number:</strong> +234
                      {studentData?.contactInfo.phone_number}
                    </li>
                  </ul>
                </div>
                <div className="fx-cl space1">
                  <h3>{getExamTitle()}</h3>
                  {/*  TEMPORARY FUNCTION TO RENDER GNS COURSES BASED ON STUDENT'S CURRENT LEVEL AND SEMESTER */}
                  {studentData?.academicInfo?.course_of_study === "Midwifery" &&
                    getExamMWCourses()}
                  {studentData?.academicInfo?.course_of_study ===
                    "General Nursing" && getExamGNCourses()}
                  {/* PERMANENT FUCTION TO RENDER EXAM COURSES BASED ON STUDENT'S CURRENT LEVEL AND SEMESTER */}
                  {/* <ul className="g g2 space1">
                    {examCourses?.map((course, index) => (
                      <li key={index}>{course?.courseCode}</li>
                    ))}
                    {carryOver?.map((course, index) => (
                      <li key={index}>{course?.courseCode}</li>
                    ))}
                  </ul> */}
                </div>
                <div className="fx-cl spacem" style={{ marginTop: "6rem" }}>
                  <figure className="examsCardPVSig">
                    <img src={provostSig} alt="" />
                  </figure>
                  <p>
                    <strong>Provost Signature</strong>
                  </p>
                  <p>
                    <em style={{ fontSize: "1rem" }}>
                      NOTE: This slip is not valid until stamped by your
                      Department Exams Officer
                    </em>
                  </p>
                </div>
              </div>
              <div className="fx-cl space1">
                <h3>EXAMINATION REGULATIONS</h3>

                <ol className="regulations">
                  <li>
                    Candidate should be within the vicinity of the Examination
                    Hall at least 15 minutes before commencement.
                  </li>
                  <li>
                    Any student without Examination and Identity cards will not
                    be allowed into Examination Hall.
                  </li>
                  <li>
                    Candidates are required to sign the attendance sheet
                    provided by the invigilator.
                  </li>
                  <li>
                    No candidate will be permitted to:
                    <ul>
                      <li>Enter the hall more than 30 minutes late.</li>
                      <li>Leave before 45 minutes after start.</li>
                      <li>Leave during the last 15 minutes.</li>
                      <li>Give/receive help from fellow candidates.</li>
                    </ul>
                  </li>
                  <li>No papers/books/handbags allowed.</li>
                  <li>Write only admission numbers on answer booklets.</li>
                  <li>Raise hand to attract attention of invigilator.</li>
                  <li>No writing on this card.</li>
                  <li>No movement around premises.</li>
                  <li>
                    No mobile phones, smartwatches or digital devices allowed.
                  </li>
                  <li>Nursing mothers cannot bring babies inside.</li>
                  <li>
                    Female students with face covering must be identified.
                  </li>
                  <li>No notes/materials allowed on seats.</li>
                </ol>
                <p className="agreement fs1">
                  I hereby agree to abide by the regulations above and those
                  contained in the students' Handbook.
                </p>

                <div className="signature fx-cl spacem">
                  <span>Student's Signature</span>
                  <figure className="examsCardStudSig">
                    <img src={studentData?.personalInfo?.signature} alt="" />
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button className="printButton" onClick={() => window.print()}>
          Print
        </button>
      </section>
    </>
  );
}
